module.exports = __webpack_public_path__ + "img/loginLogo.fe4f9bd5.png";